var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObEndCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#ED1B2E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#OBEndCall_svg__clip0_3972_6628)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.03 12.93C9.783 11.292 11.099 10 12.632 10h3.44c.382 0 .724.237.859.594l1.334 3.55a.918.918 0 01.043.49l-.449 2.413a.917.917 0 11-1.803-.336l.402-2.16-1.02-2.717h-2.806c-.536 0-.85.414-.788.823.255 1.686.846 4.284 2.2 6.76a.917.917 0 11-1.61.88c-1.495-2.734-2.131-5.564-2.404-7.367zm17.487-1.744a.917.917 0 011.297 1.297l-8.733 8.734c.517.393 1.113.762 1.8 1.122l3.466-.672a.918.918 0 01.501.043l3.562 1.358c.355.135.59.476.59.857v3.287c0 1.624-1.434 2.958-3.127 2.59-2.534-.551-7.024-1.869-10.578-4.8l-3.99 3.99a.917.917 0 11-1.298-1.297l16.51-16.51zm-9.918 12.512c3.193 2.574 7.256 3.788 9.663 4.312.445.096.904-.235.904-.798v-2.655l-2.727-1.04-3.52.683a.917.917 0 01-.586-.08c-.963-.484-1.815-1.005-2.56-1.596L17.6 23.698z",
    fill: "#1C1D1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "OBEndCall_svg__clip0_3972_6628"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 10)",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgObEndCall;